export function LoadingSpinner() {
  return (
    <div className="h-32 w-full flex justify-center items-center">
      <img
        src="/logo-aaa.png"
        className="animate-pulse duration-700 size-12 dark:invert"
        alt="logo"
      />
    </div>
  );
}
